import { css } from '@emotion/css';

import {
  Colors,
  FontSize,
  FontWeight,
  MEDIUM_DEVICE_MQ,
  Spacing,
} from 'apps/shared/scripts/styles/constants';

export const successClassName = css({
  marginTop: Spacing.MD,
  marginLeft: 'auto',
  marginRight: 'auto',
  maxWidth: '100%',
  [MEDIUM_DEVICE_MQ]: {
    maxWidth: 400,
  },
});

export const successHeaderClassName = css({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  textAlign: 'center',
});

export const iconWrapperClassName = css({
  border: `3px solid ${Colors.Green}`,
  borderRadius: 100,
  padding: Spacing.SM,
});

export const iconClassName = css({
  color: Colors.Green,
  height: 28,
  width: 28,
});

export const headingClassName = css({
  color: Colors.Primary,
  fontSize: 20,
  fontWeight: FontWeight.SEMI_BOLD,
  marginTop: Spacing.MD,
});

export const subheadingClassName = css({
  color: Colors.Secondary,
  fontSize: FontSize.REGULAR,
  fontWeight: FontWeight.NORMAL,
  marginTop: Spacing.SM,
});

export const successActionsClassName = css({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  marginTop: Spacing.LG,
});

export const buttonClassName = css({
  background: Colors.Brand,
  border: `2px solid ${Colors.Brand}`,
  borderRadius: 8,
  color: Colors.White,
  fontSize: FontSize.COMPACT,
  fontWeight: FontWeight.SEMI_BOLD,
  width: '100%',
  '&:hover': {
    opacity: 0.9,
  },
});

export const linkClassName = css({
  color: Colors.Secondary,
  fontSize: FontSize.COMPACT,
  fontWeight: FontWeight.MEDIUM,
  marginTop: Spacing.LG,
  '&:hover': {
    textDecoration: 'underline',
  },
});

export const successBodyClassName = css({
  marginTop: Spacing.LG,
});
